module.exports = __webpack_public_path__ + "static/media/ilustracion-digital.44ba4ac6.jpg";